// @flow

import createApiModule from "../create-api-module";
import { type PathParams } from "./options.d";

const { reducer, actions } = createApiModule(
    "options",
    ({ uuid }: PathParams) =>
        `/ays-series-event-management/series/${uuid}/options`,
);

export const load = (uuid: string) => (dispatch: *) => {
    return dispatch(actions.load({ path: { uuid } }));
};

export const refetch = actions.refetch;
export const clear = actions.clear;
export default reducer;
